import PlacementCard from './PlacementCard';
import * as React from 'react';
import { motion } from 'framer-motion';

// interface Props {
//   techStudents: User;
//   nonTechStudents :
// }

const PlacementMarquee = ({ techStudents, nonTechStudents }) => {
  // Combine and label students
  const combinedStudents = [
    ...(techStudents?.map((s) => ({ ...s, isNonTech: false })) || []),
    ...(nonTechStudents?.map((s) => ({ ...s, isNonTech: true })) || []),
  ];

  // Duplicate for seamless loop
  const duplicatedStudents = [...combinedStudents, ...combinedStudents];

  if (combinedStudents.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="relative overflow-hidden  py-3 rounded-xl  mb-6"
    >
      {/* Scrolling content */}
      <motion.div
        className="flex"
        animate={{ x: ['0%', '-100%'] }}
        transition={{
          repeat: Infinity,
          repeatType: 'loop',
          duration: combinedStudents.length,
          ease: 'linear',
        }}
      >
        {duplicatedStudents.map((student, i) => (
          <PlacementCard
            key={`${student.id}-${i}`}
            student={student}
            isNonTech={student.isNonTech}
          />
        ))}
      </motion.div>
    </motion.div>
  );
};

export default PlacementMarquee;
